import { Material } from '@/app/entities/Material'
import { cn } from '@/app/utils/cn'
import { withCdn } from '@/app/utils/withCdn'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { Lock } from 'lucide-react'
import { getMaterialImages, materialIsClosed } from '../MaterialPage/helper'
import { PARTNER_LOGO } from "@/app/utils/getPartnerLogo";

interface MaterialCardProps {
  material: Material
  onSelectMaterial: (material: Material) => void
  isSelected: boolean
}

export const MaterialCard = ({
  material,
  onSelectMaterial,
  isSelected,
}: MaterialCardProps) => {
  const imgs = getMaterialImages(material)
  const isClosed = materialIsClosed(material)

  const thumbnailUrl = imgs.find((img) =>
    ['png', 'jpg', 'jpeg'].includes(img.split('.').pop() as string),
  )

  return (
    <div
      className={cn(
        'flex h-[285px] w-[206px] cursor-pointer flex-col gap-3 rounded-md bg-[#F7F7F7] p-2 hover:border-2 hover:border-solid hover:border-primary/20',
        {
          'border-2 border-solid border-primary': isSelected,
        },
      )}
      onClick={() => {
        if (isClosed) return
        onSelectMaterial(material)
      }}
    >
      <div className="relative rounded-lg bg-black/5">
        {isClosed && (
          <div className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary p-2">
            <Lock className="text-white" size={16} />
          </div>
        )}
        <img
          src={thumbnailUrl ? withCdn(thumbnailUrl) : PARTNER_LOGO}
          alt={material.name}
          className={cn(
            'relative aspect-square rounded-md object-contain',
            !thumbnailUrl && 'rounded-xl opacity-80 ',
            {
              grayscale: isClosed,
            },
          )}
        />
      </div>

      <div className="flex flex-col gap-1 p-2">
        <p className="truncate font-semibold capitalize">{material.name}</p>
        <span className="text-xs text-black04">
          {format(new Date(material.dateLiberation), 'dd/MM/yyyy', {
            locale: ptBR,
          })}
        </span>
      </div>
    </div>
  )
}
